import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { Trans } from '@lingui/macro';
import ouiStyle from '@goldwasserexchange/oui-style';
import { useAtomValue } from 'jotai';
import { pathnameUrlLanguageAtom, ValidSections } from '../../../../history';
import { OnboardingLinkContainer } from './components';

export const CreateAccountLink = () => {
  const language = useAtomValue(pathnameUrlLanguageAtom);
  return (
    <OnboardingLinkContainer>
      <ouiDom.A.AButton
        to={`/${language}/${ValidSections.ONBOARDING}`}
        backgroundColor={ouiStyle.Constants.Colors.primary}
        hoverBackgroundColor={ouiStyle.Constants.Colors.primaryDarker}
        borderColor={ouiStyle.Constants.Colors.primary}
        color={ouiStyle.Constants.Colors.inverted}
        lineFactor={1.25}
        widthLines={7.5}
      >
        <Trans>
          Ouvrir un compte
        </Trans>
      </ouiDom.A.AButton>
    </OnboardingLinkContainer>
  );
};
